import styled from 'styled-components'

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 15px;
`
